import axios from 'axios';

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor de solicitudes
instance.interceptors.request.use((config) => {
  if (config) {
    if (config.method === 'post') {
      config.headers = {
        ...config.headers,
        Accept: 'application/json'
      };
    }
    return config;
  }
  return {};
}, (error) => {
  console.error("Error en la solicitud:", error);
  return { data: [] }; // Maneja el error y retorna un array vacío en caso de error de configuración
});

// Interceptor de respuestas
instance.interceptors.response.use(
  (response) => response, // Devolver la respuesta si no hay errores
  (error) => {
    console.error("Error en la respuesta:", error.message);
    // En caso de timeout o cualquier otro error, devolver un array vacío
    return { data: [] };
  }
);

export default instance;
